// extracted by mini-css-extract-plugin
export var aggregationCell = "_2s-p";
export var aggregationRow = "_2s-o";
export var borderlessSpinnerContainer = "_2s-3";
export var cardLayout = "_2s-6";
export var cardLayoutNoFooter = "_2s-a";
export var cardLayoutPageControl = "_2s-9";
export var cardLayoutWithFooter = "_2s-8";
export var closeIcon = "_2s-h";
export var columnHeaderSurface = "_2s-d";
export var columnHeaderSurfaceDragOverlay = "_2s-x";
export var columnHeaderSurfaceResizing = "_2s-u";
export var contextMenuAnchor = "_2s-1";
export var draggableColumnHeader = "_2s-v";
export var draggableColumnHeaderOverlay = "_2s-w";
export var expandIcon = "_2s-i";
export var expanded = "_2s-j";
export var filterDropdown = "_2s-k";
export var filterDropdownDivider = "_2s-f";
export var filterDropdownHeader = "_2s-n";
export var filterDropdownItem = "_2s-m";
export var filterDropdownModal = "_2s-l _2s-k";
export var filterItem = "_2s-e";
export var normalCellWithAdjustableBorder = "_2s-g";
export var pinButtonContainer = "_2s-q";
export var pinIcon = "_2s-r";
export var pinIconActive = "_2s-s";
export var spinner = "_2s-0";
export var spinnerContainer = "_2s-2";
export var tableContainer = "_2s-4";
export var tableContentDraggingColumns = "_2s-c";
export var tableContentInner = "_2s-7";
export var tableContentInnerFill = "_2s-b";
export var tableContentWrapper = "_2s-5";
export var viewButtonContainer = "_2s-t";